import { useParams } from 'react-router';
import { useState, useEffect } from 'react';
import PrepareFetch from '../helpers/PrepareFetch';
import { Skeleton } from '@mui/material';
import StyledButton from '../atom/Button';
import alertSkeleton from "../assets/icons/alertSkeleton.svg";

import PageContainer from "../components/PageContainer";
import PageContent from "../atom/PageContent";
import LuckyNumberPageContent from '../components/LuckyNumberPageContent';
import styled from 'styled-components';
import { CoverStyles } from '../components/LuckyNumberPageSection/cover';

const CustomPageContent = styled(PageContent)`
    margin-top: 1rem !important;

    .warningBlock {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
        height: auto;
        border-radius: .5rem;
        background: var(--color-xLightGray);
        color: var(--color-gray);
        justify-content: center;
        align-items: center;
    }

    ${CoverStyles}  
`;

const CampaignPromotion = () => {
    const params = useParams();
    const id = params.id;

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [data, setData] = useState({});
    const [pageTitle, setPageTitle] = useState('Carregando...');

    const loadData = () => {
        let fetchParams = PrepareFetch(`/proxy/services/apexrest/api/v1/luckynumber/promotions/${id}`,"GET",{
            "cache-by": "user"
        });

        (async () => {
            setLoading(true);
            setError(false);
            await fetch(fetchParams.url, fetchParams.options)
                    .then(response => {
                        if(response.status === 200) {
                          return response.json();
                        }
      
                        throw new Error(response);
                    })
                    .then(json => {
                        setLoading(false);
                        setData(json);
                        setPageTitle(json.name);
                        console.log(json);
                    })
                    .catch(error => {
                        setLoading(false);
                        setError(true);
                    });
        })();
    }

    useEffect(() => {
        loadData();
    },[]);

    return (
        <PageContainer pageTitle={pageTitle +" | "+ process.env.REACT_APP_SITE_NAME}>
            <CustomPageContent>
                {loading && (
                    <Skeleton variant='rectangular' className='luckyNumber__cover'/>
                )}
                {!loading && (error || !data.pageConfig) && (
                    <div className="warningBlock luckyNumber__cover">
                        <img src={alertSkeleton} alt="" />
                        Ocorreu um erro ao carregar o conteúdo.
                        <StyledButton onClick={loadData} className="secondary small" style={{borderRadius: ".5rem"}}>
                            Tentar novamente
                        </StyledButton>
                    </div>
                )}
                {!loading && !error && data.pageConfig && (
                    <LuckyNumberPageContent pageData={data} reload={loadData} />
                )}
            </CustomPageContent>
        </PageContainer>
    );
};

export default CampaignPromotion;